export default __webpack_public_path__ + "static/media/User.de6d5c8e.svg";